import fetch from "isomorphic-fetch"
import { pendingTask, begin, end } from "react-redux-spinner"
import {
  NOTIFICATION_LIST_REQUEST,
  NOTIFICATION_LIST,
  NOTIFICATION_LIST_ERROR
} from "./types"

export default function fetchNotifications() {
  return dispatch => {
    dispatch(fetchNotificationsRequest())
    return fetch(`${process.env.REACT_APP_EF_API_URL}/notifications/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token")
      }
    })
      .then(res => res.json())
      .then(json => {
        dispatch(fetchNotificationsSuccess(json.notifications))
      })
      .catch(error => dispatch(fetchNotificationsFailure(error)))
  }
}

export function fetchNotificationsFailure(error) {
  console.log("error fetching notifications" + error)
  const data = {
    error,
    loading: false
  }
  return {
    type: NOTIFICATION_LIST_ERROR,
    [pendingTask]: end,
    payload: data
  }
}

export function fetchNotificationsRequest() {
  console.log("fetching notifications")
  const data = {
    loading: true
  }
  return {
    type: NOTIFICATION_LIST_REQUEST,
    [pendingTask]: begin,
    payload: data
  }
}

export function fetchNotificationsSuccess(notifications) {
  //console.log("notifications action: " + JSON.stringify(notifications))
  const data = {
    loading: false,
    notifications
  }
  return {
    type: NOTIFICATION_LIST,
    [pendingTask]: end,
    payload: data
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/notification_list.js
 **/